// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---customer-century-21-maison-blanche-page-template-12-advices-page-tsx": () => import("./../../../customer/Century21MaisonBlanche/page-template/12-advices-page.tsx" /* webpackChunkName: "component---customer-century-21-maison-blanche-page-template-12-advices-page-tsx" */),
  "component---customer-century-21-maison-blanche-page-template-files-page-tsx": () => import("./../../../customer/Century21MaisonBlanche/page-template/files-page.tsx" /* webpackChunkName: "component---customer-century-21-maison-blanche-page-template-files-page-tsx" */)
}

